import React, { Component } from 'react';
import styled  from 'styled-components';
import { Link } from 'react-router-dom';
import Header from './header.component.js';

const Background = styled.div`
    background-color:#f8f9fa !important; 
    border-radius:10px;
    padding: 10px;
    margin: 10px;
`;

class Club extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }
      
	render() {
    	return (
            <div>
                <div className="container opacity90">
                    <Header text="Der Förderverein der KiTa Bongartzstift" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Background>
                                <br />
                                <h2>
                                    Liebe Eltern, Verwandte, Freunde und Interessierte!
                                </h2>
                                vor nicht allzu langer Zeit kam der Gedanke zur Gründung eines Fördervereins zugunsten der Städtischen Kindertagesstätte Bongartzstift auf.
                                Infolgedessen haben wir am 2. September 2013 unseren Förderverein gegründet und den ersten <Link to={"/beitreten"}>Vorstand</Link> gewählt.
                                <br />
                                <br />
                                <h2>
                                    Was sind die Ziele unseres Fördervereins?
                                </h2>
                                Unser primäres Ziel ist es, unsere Kinder und damit die Erziehungs- und Bildungsarbeit unseres Kindergartens zu unterstützen.
                                Anschaffungen wie beispielsweise Spielgeräte, Inneneinrichtungen, Musikinstrumente, Spiele, Bücher etc. 
                                können so unterstützt und finanziert werden.
                                <br />
                                <br />
                                <h2>
                                    Welche Vorteile haben der Kindergarten und unsere Kinder durch unseren Förderverein?
                                </h2>
                                Unser Verein stellt sicher, dass Spenden, Beiträge und Einnahmen (an die Einrichtung gestellt oder aus Veranstaltungen erzielt) 
                                direkt unseren Kindern zu Gute kommen.
                                <br />
                                <br />
                                {
                                /*
                                <h2>
                                    Was hat der Förderverein bereits realisiert?
                                </h2>
                                Hier finden Sie einige Impressionen, was der Förderverein bereits für die Kinder realisieren konnte.
                                <Carousel key="carousel" />
                                <br />
                                <br />
                                */
                                }
                                <h2>
                                    Wir benötigen zur Verwirklichung unserer Vorhaben Ihre Unterstützung!
                                </h2>
                                Nicht nur Ihre Mitgliedschaft, sondern auch wertvolle Anregungen, Spenden und aktive Mithilfe sind uns herzlich willkommen.
                                Wenn wir alle mit anfassen, dann werden sich unsere Kinder noch viele Jahre später an die schönste Zeit Ihrer Kindheit in 
                                der Kindertagesstätte Bongartzstift erinnern.
                                <br />
                                <br />
                                <h2>
                                    Wer kann Mitglied werden?
                                </h2>
                                Mitglied unseres Vereins kann auf schriftlichen Antrag jede natürliche Person werden, die mindestens 18 Jahre alt ist oder 
                                jede juristische Person, die den Zweck des Vereins zu fördern bereit ist.
                                D.h. Eltern, Erzieher/innen, Freunde und Gönner der Kindertagesstätte können die Mitgliedschaft erwerben.
                                <br />
                                (siehe <Link to={"/beitreten"}>Beitritt</Link>)
                                <br />
                                <br />
                                <h2>
                                    Was kostet die Mitgliedschaft?
                                </h2>
                                Unser Mitgliedsbeitrag ist zurzeit auf einen Beitrag von 12,- € des laufenden Kalenderjahres festgelegt.
                                Für jeden höheren Beitrag sind wir natürlich dankbar.
                                Darüber hinaus freuen wir uns auch über Ihre Spenden.
                                <br />
                            </Background>
                        </div>
                    </div>
                </div>
            </div>
    	);
  	}
}

export default Club;


// WEBPACK FOOTER //
// ./src/components/club.component.js